import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import BASE_URL from "../../BASEURL";

export default function EditContactCMS() {
  const navigate = useNavigate();
  const { id } = useParams();

  const [form, setForm] = useState({
    phone: "",
    email: "",
    address: "",
    mapUrl: "",
  });

  const [saving, setSaving] = useState(false);
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState("");

  // GET DATA
  useEffect(() => {
    if (!id) return;

    setLoading(true);
    fetch(`${BASE_URL}/api/contact/${id}`)
      .then(res => {
        if (!res.ok) throw new Error(`Error: ${res.status}`);
        return res.json();
      })
      .then(data => {
        const contact = data.contact || data;
        setForm({
          phone: contact.phone || "",
          email: contact.email || "",
          address: contact.address || "",
          mapUrl: contact.mapUrl || "",
        });
        setMessage("");
      })
      .catch(err => {
        console.error("Fetch error:", err);
        setMessage("Failed to load data ❌");
      })
      .finally(() => setLoading(false));
  }, [id]);

  const handleChange = (key, value) => {
    setForm({ ...form, [key]: value });
  };

  const saveData = async () => {
    setMessage("");
    setSaving(true);

    try {
      // UPDATE
      const res = await fetch(`${BASE_URL}/api/contact/update/${id}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form),
      });

      const data = await res.json();
      if (!res.ok) throw new Error(data.message || "Update failed");

      // 🔁 GET UPDATED DATA AGAIN
      const fresh = await fetch(`${BASE_URL}/api/contact/${id}`);
      const freshData = await fresh.json();
      const contact = freshData.contact || freshData;

      setForm({
        phone: contact.phone || "",
        email: contact.email || "",
        address: contact.address || "",
        mapUrl: contact.mapUrl || "",
      });

      setMessage("Saved successfully ✅");

      setTimeout(() => {
        navigate("/admin/contactcms");   // CMS list page
      }, 800);

    } catch (err) {
      setMessage(err.message || "Save failed ❌");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="max-w-5xl mx-auto p-6">
      <h1 className="text-2xl font-bold mb-6 text-primary">Edit Contact</h1>

      {loading ? (
        <div className="text-center py-8">
          <p className="text-gray-600">Loading data...</p>
        </div>
      ) : (
        <div className="bg-white p-6 rounded shadow space-y-4">
        <input className="w-full border p-2 rounded"
          value={form.phone}
          onChange={(e)=>handleChange("phone",e.target.value)}
          placeholder="Phone" />

        <input className="w-full border p-2 rounded"
          value={form.email}
          onChange={(e)=>handleChange("email",e.target.value)}
          placeholder="Email" />

        <textarea className="w-full border p-2 rounded"
          value={form.address}
          onChange={(e)=>handleChange("address",e.target.value)}
          placeholder="Address" />

        <input className="w-full border p-2 rounded"
          value={form.mapUrl}
          onChange={(e)=>handleChange("mapUrl",e.target.value)}
          placeholder="Google Map URL" />

        <div className="flex justify-end gap-3">
          <button onClick={()=>navigate(-1)} className="border px-4 py-2 rounded">
            Cancel
          </button>

          <button
            onClick={saveData}
            disabled={saving}
            className="bg-primary text-white px-6 py-2 rounded">
            {saving ? "Saving..." : "Save Changes"}
          </button>
        </div>

        {message && <p className="text-sm text-green-600">{message}</p>}
      </div>
      )}
    </div>
  );
}
